export const GET_FINANCE_VEHICLE_DATA_START = "GET_FINANCE_VEHICLE_DATA_START";
export const GET_FINANCE_VEHICLE_DATA_SUCCESS = "GET_FINANCE_VEHICLE_DATA_SUCCESS";
export const GET_FINANCE_VEHICLE_DATA_FAIL = "GET_FINANCE_VEHICLE_DATA_FAIL";

export const GET_FINANCE_VEHICLE_FILLED_DATA_START = "GET_FINANCE_VEHICLE_FILLED_DATA_START";
export const GET_FINANCE_VEHICLE_FILLED_DATA_SUCCESS = "GET_FINANCE_VEHICLE_FILLED_DATA_SUCCESS";
export const GET_FINANCE_VEHICLE_FILLED_DATA_FAIL = "GET_FINANCE_VEHICLE_FILLED_DATA_FAIL";

export const SUBMIT_FINANCE_PAYMENT_START = "SUBMIT_FINANCE_PAYMENT_START";
export const SUBMIT_FINANCE_PAYMENT_SUCCESS = "SUBMIT_FINANCE_PAYMENT_SUCCESS";
export const SUBMIT_FINANCE_PAYMENT_FAIL = "SUBMIT_FINANCE_PAYMENT_FAIL";

export const RESET_FINANCE_FORM_DATA = "RESET_FINANCE_FORM_DATA";

export const SET_SELECTED_PAYMENT_DETAILS = "SET_SELECTED_PAYMENT_DETAILS";
